import React from 'react';
import { motion } from 'framer-motion';
export function PersonalLetter() {
  return <section className="py-8 md:py-20 bg-white" data-id="element-285">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-286">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-287">
          <h2 className="text-3xl md:text-4xl font-serif text-navy mb-6 md:mb-10 text-center" data-id="element-288">
            Querida familia,
          </h2>

          <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 items-start" data-id="element-289">
            {/* Portrait image — sticky on desktop */}
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.7
          }} className="lg:col-span-5 order-1" data-id="element-290">
              <div className="relative lg:sticky lg:top-24" data-id="element-291">
                <div className="absolute -inset-3 bg-gradient-to-br from-gold/30 via-gold/10 to-navy/20 rounded-2xl blur-2xl" data-id="element-292" />
                <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-293">
                  <img src="https://cdn.magicpatterns.com/uploads/2Vaa3auuwKR42sbvyHVQ2L/hf_20260414_043757_d7baaa6b-918f-43a9-926f-b3e8986ad3d5_(1).png" alt="Anisley Estanque en su oficina" className="w-full h-full object-cover" data-id="element-294" />
                  {/* Bottom name plate caption */}
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-navy via-navy/90 to-transparent p-4 md:p-6" data-id="element-295">
                    <p className="font-serif text-gold text-lg md:text-xl font-bold tracking-wide" data-id="element-296">
                      Anisley Estanque
                    </p>
                    <p className="text-white/85 text-xs md:text-sm uppercase tracking-[0.2em] mt-1" data-id="element-297">
                      Agente de Seguros Licenciada
                    </p>
                    <p className="text-gold/90 italic text-xs md:text-sm mt-2 font-serif" data-id="element-298">
                      "Su tranquilidad es mi compromiso"
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Letter content */}
            <div className="lg:col-span-7 order-2 prose prose-lg prose-navy max-w-none" data-id="element-299">
              <p className="text-base md:text-lg leading-relaxed text-gray-700 mb-5" data-id="element-300">
                Permíteme hacerte una pregunta que puede cambiar tu vida para
                siempre.
              </p>

              <div className="bg-cream-dark border-l-4 border-gold p-5 md:p-6 my-6 rounded-r-lg" data-id="element-301">
                <p className="font-serif text-lg md:text-xl text-navy italic mb-3" data-id="element-302">
                  ¿Qué pasaría hoy... si mañana no pudieras trabajar?
                </p>
                <p className="font-serif text-lg md:text-xl text-navy italic mb-3" data-id="element-303">
                  ¿Qué pasaría si una enfermedad inesperada, un accidente, o una
                  emergencia médica golpeara tu puerta sin avisar?
                </p>
                <p className="font-serif text-lg md:text-xl text-navy italic font-semibold" data-id="element-304">
                  ¿Tienes un plan? ¿Tiene tu familia un plan?
                </p>
              </div>

              <p className="text-base md:text-lg leading-relaxed text-gray-700 mb-5" data-id="element-305">
                Si dudaste aunque sea un segundo antes de responder... entonces
                lo que estás a punto de leer es exactamente para ti.
              </p>

              <p className="text-base md:text-lg leading-relaxed text-gray-700 mb-5" data-id="element-306">
                Me llamo <strong data-id="element-307">Anisley Estanque</strong>, y llevo años
                ayudando a familias latinas en Florida, Texas y todo Estados
                Unidos a construir una red de protección sólida, real y
                accesible para sus seres queridos.
              </p>

              <p className="text-base md:text-lg leading-relaxed text-gray-700 mb-5" data-id="element-308">
                He visto de todo. He visto familias que trabajaron 20 años
                construyendo su estabilidad... destruida en 3 meses por una
                hospitalización sin seguro.
              </p>

              <p className="text-base md:text-lg leading-relaxed text-gray-700 mb-5" data-id="element-309">
                He visto padres que no pudieron llevar a sus hijos al dentista
                por años... porque "era muy caro"... sin saber que existían
                planes que caben perfectamente en su presupuesto.
              </p>

              <p className="text-base md:text-lg leading-relaxed text-gray-700 mb-5" data-id="element-310">
                He visto personas perder su visión progresivamente... porque
                nunca tuvieron acceso a un seguro de visión que les cubriera sus
                lentes o sus chequeos anuales.
              </p>

              <p className="text-xl md:text-2xl font-serif font-semibold text-navy text-center mt-8" data-id="element-311">
                Y todo eso...{' '}
                <span className="text-gold" data-id="element-312">se puede evitar.</span>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}